<template>
  <NuxtLayout>
    <div class="app_container">
      <div
        v-loading="ctrl.tableLoading"
        class="course_content"
      >
        <div
          ref="header"
          class="course_header_content mgt20"
        >
          <div class="bg_box search_tag_list">
            <category-list
              v-for="(category, index) in opts.categoryList"
              :key="category.active"
              :index="index"
              :menu="category"
              @change="handleChange"
            />
          </div>
        </div>
        <div class="fliter_row">
          <div class="left_wrapper">
            <span
              v-for="(item, index) in opts.orderByTypeEnum"
              :key="index"
              class="search_item"
              :class="{
                active: map.orderByType === item.code,
                not_right: index === opts.orderByTypeEnum.length,
              }"
              @click="handleChangeOrderBy(item.code)"
            >{{ item.desc }}</span>
          </div>
          <div>
            <el-checkbox
              v-model="opts.isFree"
              size="default"
              @change="handleChangeCharge(opts.isFree ? 0 : '')"
            >
              免费
            </el-checkbox>
          </div>
        </div>
        <div class="ov_course_content">
          <index-grade
            :visible="opts.tableList.length > 0"
            :component-info="{ config: { }, data: opts.tableList }"
          />
        </div>
        <div
          v-show="page.totalPage > 1"
          ref="content"
          class="page_list"
        >
          <el-pagination
            v-model:currentPage="page.pageCurrent"
            background
            layout="prev, pager, next,jumper"
            :total="page.totalCount"
            :page-size="page.pageSize"
            @current-change="getTableList"
          />
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
<script setup>
import { useUserStore } from '../../stores/user'
import { getAuthCourseList, getCourseList } from '../../api/course'
import { getGradeList } from '@/api/grade'

import { categoryLists } from '../../api/system'
import { computed, nextTick, onMounted, watch } from 'vue'
import cookie from '@/utils/cookies'

const route = useRoute()
const router = useRouter()
const cookieData = cookie.getShop()
useHead({
  title: computed(() => `班级中心-${cookieData.shopName}`),
  meta: [
    {
      hid: 'keywords',
      name: 'keywords',
      content: '班级中心'
    },
    {
      hid: 'description',
      name: 'description',
      content: '班级中心'
    }
  ]
})
const store = useUserStore()
const { getToken, getEnumList } = store
const header = ref(null)
const content = ref(null)
const map = reactive({
  courseType: '',
  categoryId: '',
  chargeType: '',
  orderByType: 1
})
const token = computed(() => {
  return getToken()
})
const opts = reactive({
  errorNum: 0,
  lastCategory: [],
  tableList: [],
  categoryList: [],
  chargeTypeEnum: [],
  PeriodTypeEnum: [],
  orderByTypeEnum: [],
  categoryChild: {},
  infoTimer: null,
  style: {
    height: '525px'
  },
  isFree: false
})
const ctrl = reactive({
  tableLoading: false
})
const page = reactive({
  pageCurrent: 1,
  pageSize: 20,
  totalCount: 0,
  totalPage: 1
})

const getChangeKeys = (key) => {
  const arr = Object.keys(opts.categoryChild)
  let returnKey = 'children-1'
  for (let j = 0; j < arr.length; j++) {
    returnKey += '-1'
    if (arr[j] === key) {
      break
    }
  }
  return returnKey
}
const getTableList = () => {
  ctrl.tableLoading = true
  getGradeList({
    pageCurrent: page.pageCurrent,
    pageSize: page.pageSize,
    ...map
  }).then((res) => {
    ctrl.tableLoading = false
    opts.tableList = res.list || []
    page.pageCurrent = res.pageCurrent
    page.totalCount = res.totalCount
    page.totalPage = res.totalPage
    if (opts.infoTimer) {
      clearInterval(opts.infoTimer)
      opts.infoTimer = null
    }
  }).catch(() => {
    ctrl.tableLoading = false
    opts.errorNum++
    if (!opts.infoTimer) {
      opts.infoTimer = setInterval(getTableList, 3000)
    }
    if (opts.errorNum > 5) {
      if (opts.infoTimer) {
        clearInterval(opts.infoTimer)
        opts.infoTimer = null
      }
    }
  })
}
const handleChangeType = (val) => {
  // 课程分类
  map.courseType = val
  const query = route.query || {}
  router.replace({
    query: Object.assign({ ...query }, { courseType: val }, () => {})
  })
}
const getData = (query) => {
  if (query.courseType) {
    map.courseType = Number(query.courseType)
  }
  if (query.orderByType) {
    map.orderByType = Number(query.orderByType)
  }

  if (query.categoryId) {
    map.categoryId = query.categoryId
  } else {
    map.categoryId = ''
  }

  if (query.chargeType) {
    map.chargeType = Number(query.chargeType)
  }

  page.pageCurrent = 1
  getTableList()
}
const handleChangeCharge = (val) => {
  // 收费状态
  map.chargeType = val
  const query = route.query || {}
  router.replace({
    query: Object.assign({ ...query }, { chargeType: val }, () => {})
  })
}
const handleChangeOrderBy = (val) => {
  // 排序
  map.orderByType = val
  const query = route.query || {}
  router.replace({
    query: Object.assign({ ...query }, { orderByType: val }, () => {})
  })
}

const getCategoryObj = (list, id) => {
  // 获取分类对象
  let obj = null
  list.forEach((el) => {
    if (el.id === id) {
      obj = el
    }
    if (el.childrenList && el.childrenList.length > 0 && !obj) {
      obj = getCategoryObj(el.childrenList, id)
    }
  })
  return obj || {}
}

if (route.query.courseType) {
  map.courseType = Number(route.query.courseType)
}
if (route.query.orderByType) {
  map.orderByType = Number(route.query.orderByType)
}
if (route.query.categoryId) {
  map.categoryId = route.query.categoryId
}
if (route.query.chargeType) {
  map.chargeType = Number(route.query.chargeType)
}

let selectCategory = []
// 分类查询更换
const handleChange = (index, row) => {
  if (selectCategory[index] !== row.id) {
    selectCategory[index] = row.id
    if (row.childrenList && row.childrenList.length) {
      if (opts.categoryList.length > index + 1) {
        opts.categoryList.length = index + 1
      }
      opts.categoryList.push({
        active: row.id,
        all: row.id,
        list: [{ id: row.id, categoryName: '全部' }].concat(row.childrenList)
      })
    } else {
      opts.categoryList.length = index + 1
      selectCategory.length = index + 1
    }
  }

  const query = Object.assign({ ...(route.query || {}) }, { categoryId: selectCategory[selectCategory.length - 1] || '' })
  if (!query.categoryId) {
    delete query.categoryId
  }
  router.push({
    query
  })
}
const { data, pending, error } = await useAsyncData('courseListPage', () => {
  return new Promise(async (resolve) => {
    // 课程列表的请求
    const courseParam = {
      pageCurrent: page.pageCurrent,
      pageSize: page.pageSize,
      ...map
    }
    Promise.allSettled([
      getGradeList(courseParam),
      getEnumList('CourseTypeEnum', 'arr'),
      getEnumList('ChargeTypeEnum', 'arr'),
      getEnumList('OrderByTypeEnum', 'arr'),
      categoryLists({})
    ]).then(([course, CourseTypeEnum, ChargeTypeEnum, OrderByTypeEnum, categoryList]) => {
      const data = {}
      if (course.status === 'fulfilled') {
        data.course = course.value
      } else {
        data.course = {}
      }
      if (CourseTypeEnum.status === 'fulfilled') {
        data.CourseTypeEnum = CourseTypeEnum.value
      } else {
        data.CourseTypeEnum = []
      }
      if (ChargeTypeEnum.status === 'fulfilled') {
        data.ChargeTypeEnum = ChargeTypeEnum.value
      } else {
        data.ChargeTypeEnum = []
      }
      if (OrderByTypeEnum.status === 'fulfilled') {
        data.OrderByTypeEnum = OrderByTypeEnum.value
      } else {
        data.OrderByTypeEnum = []
      }
      if (categoryList.status === 'fulfilled') {
        data.categoryList = categoryList.value
      } else {
        data.categoryList = []
      }

      resolve(data)
    })
  })
}, { initialCache: false })
if (!pending.value && data.value) {
  const d = data.value
  opts.chargeTypeEnum = d.ChargeTypeEnum
  opts.PeriodTypeEnum = d.CourseTypeEnum
  opts.orderByTypeEnum = d.OrderByTypeEnum
  if (d && d.course) {
    ctrl.tableLoading = false
    opts.tableList = d.course.list || []
    page.pageCurrent = d.course.pageCurrent
    page.totalCount = d.course.totalCount
    page.totalPage = d.course.totalPage
  }

  if (d.categoryList && d.categoryList.length) {
    if (route.query.categoryId) {
      const classifyIdObj = {}
      const key = []
      const init = (list, prefixId) => {
        list.forEach(e => {
          if (e.id) {
            const id = prefixId + '_' + e.id
            key.push(id)
            classifyIdObj[e.id] = e
            if (e.childrenList && e.childrenList.length) {
              return init(e.childrenList, id)
            }
          }
        })
      }
      init(d.categoryList, '')
      const lists = key.filter(e => e.indexOf(route.query.categoryId) > -1)
      if (lists && lists.length) {
        lists.sort((a, b) => {
          return a.length - b.length
        })
        const ids = lists[0].split('_')
        if (ids && ids.length) {
          opts.categoryList.push({
            active: ids[1],
            all: '',
            list: [{ id: '', categoryName: '全部' }].concat(d.categoryList)
          })
          ids.forEach((e, index) => {
            const item = classifyIdObj[e]
            if (item) {
              selectCategory.push(e)
              if (item.childrenList.length) {
                opts.categoryList.push({
                  active: ids[index + 1] || e,
                  all: e,
                  list: [{ id: e, categoryName: '全部' }].concat(item.childrenList)
                })
              }
            }
          })
        }
      }
    } else {
      selectCategory = ['']
      opts.categoryList.push({
        active: '',
        all: '',
        list: [{ id: '', categoryName: '全部' }].concat(d.categoryList)
      })
    }
  }
}
// router.beforeResolve((to) => {
//   if(to.path === '/course/list') {
//     if(to.query.courseType !==  map.courseType || to.query.orderByType !== map.orderByType || to.query.chargeType !== map.chargeType || to.query.categoryId !== map.categoryId) {
//       getData(to.query);
//     }
//   }
// });
watch(() => route.fullPath, () => {
  if (route.path === '/grade/list') {
    if (Number(route.query.courseType) !== map.courseType || Number(route.query.orderByType) !== map.orderByType || Number(route.query.chargeType) !== map.chargeType || route.query.categoryId !== map.categoryId) {
      getData(route.query)
    }
  }
})
onUnmounted(() => {
  if (opts.infoTimer) {
    clearInterval(opts.infoTimer)
    opts.infoTimer = null
  }
})

</script>

<style scoped lang="scss">
.course_content {
  width: 1200px;
  margin: auto;
  background: #f6f8fb;
  .course_header_content {
    padding: 18px 20px 4px 20px;
    margin-bottom: 15px;
    background: #fff;
    border-radius: 5px;
  }
}

.app_container {
  overflow: auto;
}

.ov_course_content {
  margin-top: 20px;
  margin-bottom: 20px;
  //overflow: auto;
}

.page_list {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg_box {
  width: 100%;
  background-color: #ffffff;
  //border-radius: 5px;
  //padding: 5px 10px;

  &:first-child {
    //margin-top: 20px;
  }

  & + .bg_box {
    //margin-top: 10px;
  }
}

.search_tag_list {
  //padding: 10px 20px;
}

.search_type_list {
  // min-height: 50px;
  display: flex;
  //align-items: center;
  //flex-wrap: wrap;

  & + .search_type_list {
    //margin-top: 10px;
  }

  .search_type_item {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    margin-right: 10px;
    padding: 10px;
    &.not_right {
      margin-right: 0;
    }

    &.active {
      color: #2256f6;
      font-weight: bold;
      background: rgba(34, 86, 246, 0.05);
      border-radius: 5px;
    }
  }
}

.border_hr {
  border: 1px solid #becadb;
  height: 14px;
  margin-left: 30px;
  margin-right: 30px;
}
.fliter_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
  .left_wrapper {
    background: #fff;
    border-radius: 40px;
    padding: 0 5px;
    .search_item {
      margin: 12px 15px;
      display: inline-block;
      cursor: pointer;
    }
    .active {
      color: #2256f6;
      font-weight: 700;
    }
  }
}
:deep(.el-checkbox__input.is-checked+.el-checkbox__label) {
  color: #333;
}
</style>
